import React from "react";
import { Header, Image } from "semantic-ui-react";

const AperturarCuentaDPFHeader = () => {
  return (
    <>
      <Header as="h1" color="blue">
        <Image src="/assets/icons/prestamo.svg" size="big" /> Apertura tu cuenta
      </Header>
    </>
  );
};

export default AperturarCuentaDPFHeader;
